import { getUserSummary, resetPassword, UpdateCustomer } from 'helpers/api';
import { formatMoney } from 'helpers/utils';
import Vue from 'vue/dist/vue';
import swal from 'sweetalert';

const accountPage = document.querySelector('#account');
if (accountPage) {
    new Vue({
        el: '#account',
        data: {
            res: null,
            showEditModal: false,
            customerRequestToggle: false,
            errorLoading: false,
            isLoading: true,
            CustomerRequestObject: {
                NetsuiteCustomerId: null,
                UserId: null,
                IsInternal: null,
                Phone: null,
                Phone_Alt1: null,
                Phone_Alt2: null,
                Phone_Alt3: null,
                Email: null,
                Email_Public: null,
                Fax: null,
                Website: null,
                UpdateContactRequestVMs: [],
            },
            password: {
                showModal: false,
                isFetching: false,
                submitted: false,
                error: {
                    input: {
                        noMatch: false,
                        notLongEnough: false,
                        sameAsOld: false,
                    },
                    responseError: {
                        exists: false,
                        text: '',
                    },
                },
                fields: {
                    oldPassword: {
                        filled: true,
                        value: '',
                    },
                    newPassword: {
                        filled: true,
                        value: '',
                    },
                },
                showOldPassword: false,
                showNewPassword: false,
            },
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        },
        filters: {
            formatMoney: function (price) {
                return formatMoney(price);
            },
        },
        computed: {
            postValues: function () {
                return {
                    oldPassword: this.password.fields.oldPassword.value,
                    newPassword: this.password.fields.newPassword.value,
                };
            },
            errorExists: function () {
                return (function (obj) {
                    let isError = false;
                    Object.keys(obj).forEach(function (key) {
                        if (obj[key]) {
                            isError = true;
                        }
                    });
                    return isError;
                })(this.password.error.input);
            },
        },
        methods: {
            setValues: async function () {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.get('showPassword')
                    ? (this.password.showModal = true)
                    : (this.password.showModal = false);
                const { status, data } = await getUserSummary();
                if (status != 200) {
                    this.errorLoading = true;
                } else {
                    this.res = data;
                    this.CustomerRequestObject = data.CustomerRequestObject;
                    // this.CustomerRequestObject.NetsuiteCustomerId = data.NetsuiteCustomerId
                    // this.CustomerRequestObject.UserId = data.UserId
                    // this.CustomerRequestObject.IsInternal = data.IsInternal
                    // this.CustomerRequestObject.Phone = data.ContactInfo.Phone
                    // this.CustomerRequestObject.AltPhone = data.ContactInfo.AltPhone
                    // this.CustomerRequestObject.Email = data.ContactInfo.Email
                    // this.CustomerRequestObject.Email_Public = data.ContactInfo.Email_Public
                    // this.CustomerRequestObject.Fax = data.ContactInfo.Fax
                    // this.CustomerRequestObject.Website = data.ContactInfo.Website
                    // this.CustomerRequestObject.Phone_Alt1 = data.ContactInfo.Phone_Alt1
                    // this.CustomerRequestObject.Phone_Alt2 = data.ContactInfo.Phone_Alt2
                    // this.CustomerRequestObject.Phone_Alt3 = data.ContactInfo.Phone_Alt3
                    // this.CustomerRequestObject.UpdateContactRequestVMs = data.ContactInfo.Contacts
                }
            },

            isEmailValid: function () {
                return this.CustomerRequestObject.Email == ''
                    ? ''
                    : this.reg.test(this.CustomerRequestObject.Email)
                        ? 'has-success'
                        : 'has-error';
            },
            isFormFilled: function (input) {
                let filled = true;

                Object.keys(input).forEach(function (key) {
                    if (
                        typeof input[key].value === 'string' &&
                        !input[key].value.replace(/\s+/g, '').length
                    ) {
                        input[key].filled = false;
                        filled = false;
                    } else if (input[key].value) {
                        input[key].filled = true;
                    } else {
                        input[key].filled = false;
                        filled = false;
                    }
                });

                return filled;
            },
            isLongEnough: function () {
                this.password.fields.newPassword.value.length >= 6
                    ? (this.password.error.input.notLongEnough = false)
                    : (this.password.error.input.notLongEnough = true);
            },
            newSameAsOld: function () {
                let sameAsOld =
                    this.password.fields.oldPassword.value ===
                    this.password.fields.newPassword.value;
                sameAsOld
                    ? (this.password.error.input.sameAsOld = true)
                    : (this.password.error.input.sameAsOld = false);
            },
            submitPassword: function (e) {
                e.preventDefault();

                if (this.isFormFilled(this.password.fields)) {
                    this.isLongEnough();
                    this.newSameAsOld();
                } else {
                    return;
                }

                if (this.errorExists) {
                    return;
                }

                this.post(this.postValues);
            },
            post: async function (passwords) {
                this.password.isFetching = true;

                const { status, data } = await resetPassword(passwords);

                if (status !== 200) {
                    this.password.error.responseError.text = data.Message;
                    this.password.error.responseError.exists = true;
                    this.password.isFetching = false;
                    return;
                }

                this.password.isFetching = false;
                this.password.submitted = true;
            },

            AddBlankContact() {
                this.CustomerRequestObject.UpdateContactRequestVMs.push({
                    NetSuiteContactId: 0,
                    Firstname: null,
                    Lastname: null,
                    Title: null,
                    Phone: null,
                    Email: null,
                    IsRemoved: false,
                });
            },

            AddBlankInvoiceEmail() {
                this.CustomerRequestObject.Invoice_Email_Recipients.push(null);
            },

            AddBlankStatementEmail() {
                this.CustomerRequestObject.Statement_Email_Recipients.push(null);
            },

            async SubmitCustomerUpdate() {
                this.isLoading = true;

                var invoiceEmailsTemp = [];
                if (this.CustomerRequestObject.Invoice_Email_Recipients.length > 0) {
                    for (
                        let i = 0;
                        i < this.CustomerRequestObject.Invoice_Email_Recipients.length;
                        i++
                    ) {
                        const invoiceEmail = this.CustomerRequestObject.Invoice_Email_Recipients[i];
                        if (invoiceEmail && invoiceEmail.trim()) {
                            if (this.reg.test(invoiceEmail.trim())) {
                                invoiceEmailsTemp.push(invoiceEmail.trim());
                            } else {
                                swal(
                                    'Warning',
                                    'Invoice Email Address is invalid- ' + invoiceEmail,
                                    'warning',
                                );
                                return;
                            }
                        }
                    }
                }
                this.CustomerRequestObject.Invoice_Email_Recipients = invoiceEmailsTemp;

                if (
                    this.CustomerRequestObject.SEND_INVOICE_BY_EMAIL &&
                    this.CustomerRequestObject.Invoice_Email_Recipients.length === 0
                ) {
                    swal(
                        'Warning',
                        'Please provide one or more Invoice Email Addresses.',
                        'warning',
                    );
                    return;
                }

                var statementEmailsTemp = [];
                if (this.CustomerRequestObject.Statement_Email_Recipients.length > 0) {
                    for (
                        let i = 0;
                        i < this.CustomerRequestObject.Statement_Email_Recipients.length;
                        i++
                    ) {
                        const statementEmail =
                            this.CustomerRequestObject.Statement_Email_Recipients[i];
                        if (statementEmail && statementEmail.trim()) {
                            if (this.reg.test(statementEmail.trim())) {
                                statementEmailsTemp.push(statementEmail.trim());
                            } else {
                                swal(
                                    'Warning',
                                    'Statement Email Address is invalid- ' + statementEmail,
                                    'warning',
                                );
                                return;
                            }
                        }
                    }
                }
                this.CustomerRequestObject.Statement_Email_Recipients = statementEmailsTemp;

                if (
                    this.CustomerRequestObject.SEND_STATEMENT_BY_EMAIL &&
                    this.CustomerRequestObject.Statement_Email_Recipients.length === 0
                ) {
                    swal(
                        'Warning',
                        'Please provide one or more Statement Email Addresses.',
                        'warning',
                    );
                    return;
                }

                const postRequest = await UpdateCustomer(this.CustomerRequestObject);

                if (postRequest.status === 200) {
                    console.log(postRequest.data.length, postRequest.data);
                    this.isLoading = false;
                    this.res.ContactInfo.HasPending = true;
                    swal('Success', 'Your request has been submitted.', 'success');
                    this.customerRequestToggle = false;
                }
            },
        },
        created() {
            this.setValues();
        },
        watch: {},
    });
}

async function init() { }
export default init;
